import React, { useEffect, useState } from 'react';
import { accountFormIsVisible, sessionKey } from '../../redux/selectors/pagesSelectors';
import {
    checkKey,
    setAccountFormIsVisible,
    setAccountFormRegisterState,
} from '../../redux/actions/pagesActions';
import { connect } from 'react-redux';
import { authEmailSelector } from '../../redux/selectors/authSelectors';
import { logout } from '../../redux/actions/authActions';
import cn from 'classnames';
import { productCurrentProductIdSelector } from '../../redux/selectors/productSelector';

function RegisterBlock({
    sessionKey,
    email,
    checkKey,
    logout,
    setFormState,
    setFormIsVisible,
    mainProductId,
}) {
    useEffect(() => {
        checkKey();
    }, []);

    const openRegistrationForm = () => {
        setFormState(false);
        setFormIsVisible(true);
    };

    const openLoginForm = () => {
        setFormState(true);
        setFormIsVisible(true);
    };

    const logoutHandler = () => {
        logout({ product_id: mainProductId });
    };

    return (
        <div className={'header__user-info header__link-border'}>
            {sessionKey ? (
                <ul className={'header__list'}>
                    {email && (
                        <li>
                            <div className={'header__email-block'}>
                                <span className={'color--dark-grey hide-tablet pr-4'}>
                                    Account is
                                </span>{' '}
                                <span className={'header__mail'}>{email}</span>
                            </div>
                        </li>
                    )}
                    <li>
                        <button type={'button'} onClick={logoutHandler} className={'header__link'}>
                            Logout
                        </button>
                    </li>
                </ul>
            ) : (
                <ul className={'header__list'}>
                    <li>
                        <button onClick={openLoginForm} className={'button--reset'}>
                            <span className={'text-3 color--blue'}>Sign In</span>
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={openRegistrationForm}
                            className={'button--reset text color--blue-2'}
                        >
                            <span className={'text-3 color--blue'}>Create account</span>
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessionKey: sessionKey(state),
    email: authEmailSelector(state),
    formIsVisible: accountFormIsVisible(state),
    mainProductId: productCurrentProductIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    logout: (params) => dispatch(logout(params)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setFormState: (flag) => dispatch(setAccountFormRegisterState(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterBlock);
